<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>营销</el-breadcrumb-item>
            <el-breadcrumb-item>优惠券</el-breadcrumb-item>
            <el-breadcrumb-item>{{$route.query.id ? '编辑优惠券' : '添加优惠卷'}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="dis-flex">
            <div class="second-swaper">
                <second></second>
            </div>
            <div class="flex-box">
                <Card :bordered="false" dis-hover class="ivu-mt">
                    <Form
                        class="formValidate mt20"
                        ref="formValidate"
                        :rules="ruleValidate"
                        :model="formValidate"
                        :label-width="120"
                        @submit.native.prevent>
                        <FormItem label="优惠券名称：" prop="name">
                            <Input
                                v-model="formValidate.name"
                                placeholder="请输入优惠券名称"
                                v-width="'50%'"/>
                        </FormItem>
                        <FormItem label="优惠券类型：" prop="coupon_type">
                            <RadioGroup v-model="formValidate.coupon_type">
                                <Radio :label="10" class="radio">满减券</Radio>
                                <Radio :label="20">折扣券</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="减免金额：" prop="reduce_price" v-if="formValidate.coupon_type == 10">
                            <Input
                                v-model="formValidate.reduce_price"
                                placeholder=""
                                v-width="100"/><span style="margin-left: 10px">元</span>
                            <div v-if="formValidate.coupon_type == 20">折扣率范围0-10，9.5代表9.5折，0代表不折扣</div>
                        </FormItem>
                        <FormItem label="折扣率：" prop="discount" v-else>
                            <Input
                                    v-model="formValidate.discount"
                                    placeholder=""
                                    v-width="100"/><span style="margin-left: 10px">折</span>
                            <div class="mt10">折扣率范围0-10，9.5代表9.5折，0代表不折扣</div>
                        </FormItem>
                        <FormItem label="最低消费金额：" prop="min_price">
                            <Input
                                    v-model="formValidate.min_price"
                                    placeholder=""
                                    v-width="100"/><span style="margin-left: 10px">元</span>
                        </FormItem>
                        <FormItem label="到期类型：" prop="expire_type">
                            <RadioGroup v-model="formValidate.expire_type">
                                <Radio :label="10" class="radio">领取后生效</Radio>
                                <Radio :label="20">固定时间</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem style="margin-top: -20px" label="" prop="expire_day" v-if="formValidate.expire_type == 10">
                            <Input
                                    v-model="formValidate.expire_day"
                                    placeholder=""
                                    v-width="100"/><span style="margin-left: 10px">天</span>
                        </FormItem>
                        <FormItem style="margin-top: -20px" label="" prop="between_time" v-if="formValidate.expire_type == 20">
                            <DatePicker
                                    :editable="false"
                                    :value="formValidate.between_time"
                                    @on-change="onchangeTime"
                                    format="yyyy/MM/dd"
                                    type="datetimerange"
                                    placement="bottom-start"
                                    placeholder="领取后在这个时间段内可以使用"
                                    style="width: 300px"
                                    class="mr20"
                            ></DatePicker>
                        </FormItem>
                        <FormItem label="券适用范围：" prop="apply_range">
                            <RadioGroup v-model="formValidate.apply_range">
                                <Radio :label="10" class="radio">全场通用</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="发放总数量：" prop="total_num">
                            <Input
                                v-model="formValidate.total_num"
                                placeholder="请输入发放总数量"
                                v-width="'50%'"/>
                        </FormItem>
                        <FormItem label="启用状态：" prop="status">
                            <RadioGroup v-model="formValidate.status">
                                <Radio :label="1" class="radio">启用</Radio>
                                <Radio :label="0">关闭</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="优惠券描述：" prop="describe">
                            <Input type="textarea" v-model="formValidate.describe"
                                   placeholder="请输入优惠券描述"
                                   v-width="'50%'"/>
                        </FormItem>
                        <FormItem label="排序：" prop="sort">
                            <Input
                                    v-model="formValidate.sort"
                                    placeholder="请输入排序值"
                                    v-width="'50%'"/>
                        </FormItem>
                        <FormItem label="" prop="">
                            <Button
                                    type="primary"
                                    class="submission"
                                    @click="handleSubmit('formValidate')">
                                保存
                            </Button>
                        </FormItem>
                    </Form>
                </Card>
            </div>
        </div>
    </div>
</template>

<script>
    import second from "./second.vue";
    export default {
        name: "add",
        components: { second },
        data () {
            return {
                isLoad: false,
                coupon_id: 0,
                record: false,
                formValidate: {
                    coupon_type: 10,
                    status: 1,
                    total_num: 0,
                    expire_type: 10,
                    apply_range: 10,
                    sort: 100,
                    between_time: []
                },
                ruleValidate: {
                    name: [
                        {required: true, message: "请输入优惠券名称"},
                    ],
                    coupon_type: [
                        {required: true, message: "请选择优惠券类型"},
                    ],
                    reduce_price: [
                        {required: true, message: "请输入减免金额"},
                    ],
                    min_price: [
                        {required: true, message: "请输入最低消费金额"},
                    ],
                    expire_type: [
                        {required: true, message: "请选择到期类型"},
                    ],
                    expire_day: [
                        {required: true, message: "请输入有效期天数"},
                    ],
                    between_time: [
                        {required: true, message: "请选择有效期范围"},
                    ],
                    total_num: [
                        {required: true, message: "请输入发放总数量"},
                    ],
                    status: [
                        {required: true, message: "请选择显示状态"},
                    ],

                }
            }
        },
        mounted() {
            if (this.$route.query.id !== "0" && this.$route.query.id) {
                this.getInfo();
            } else if (this.$route.query.id === "0") {
            }
        },
        methods: {
            getInfo: function () {
                this.axios.post('store/app.coupon/detail', {
                    coupon_id: this.$route.query.id
                })
                .then(async (res) => {
                    if (res.code == 1) {
                        // 当前记录
                        this.record = res.data.detail
                        this.coupon_id = this.record.coupon_id
                        // 设置表单默认值
                        this.setFieldsValue()
                    }
                })
            },
            setFieldsValue: function () {
                const { record } = this

                // 表单数据
                const data = _.pick(record, [
                    'name', 'coupon_type', 'reduce_price', 'discount', 'min_price', 'status',
                    'expire_type', 'expire_day', 'apply_range', 'total_num', 'describe', 'sort',
                ])
                // 时间范围
                data.between_time = this.getBetweenTime(record)
                this.formValidate = data
            },
            // 格式化时间范围
            getBetweenTime (record) {
                if (record.expire_type === 20) {
                    return [record.start_time, record.end_time]
                }
                return ''
            },
            // 具体日期
            onchangeTime(e) {
                this.timeVal = e;
                if (e.length == 2) {
                    this.formValidate.between_time = this.timeVal
                }
            },
            // 提交
            handleSubmit(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        if (this.formValidate.reduce_price <= 0) {
                            return this.$Message.error("优惠券面值不能小于0");
                        }
                        if (this.formValidate.min_price < 1) {
                            return this.$Message.error("优惠券最低消费不能小于0");
                        }
                        var form = _.cloneDeep(this.formValidate)
                        if (this.coupon_id) {
                            this.axios.post('store/app.coupon/edit', {
                                coupon_id: this.coupon_id,
                                form: form
                            })
                            .then(async (res) => {
                                this.openSubimit = false;
                                this.$Message.success(res.msg);
                                setTimeout(() => {
                                    this.$router.push({path: "/app/coupon/list.html"});
                                }, 1500);
                            })
                            .catch((res) => {
                                this.openSubimit = false;
                                this.$Message.error(res.msg);
                            });
                        } else {
                            this.axios.post('store/app.coupon/add', {
                                form: form
                            })
                            .then(async (res) => {
                                this.openSubimit = false;
                                this.$Message.success(res.msg);
                                setTimeout(() => {
                                    this.$router.push({path: "/app/coupon/list.html"});
                                }, 500);
                            })
                            .catch((res) => {
                                this.openSubimit = false;
                                this.$Message.error(res.msg);
                            });
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
